import axios, { type AxiosError, type AxiosInstance } from 'axios'

import { env } from '@/env'

export const MENSAGEM_ERRO_GENERICO = 'Não foi possível completar a operação. Tente novamente.'

const STATUS_FALLBACK_MESSAGES: Record<number, string> = {
  400: 'Requisição inválida',
  401: 'Sessão expirada. Faça login novamente.',
  403: 'Sem permissão para realizar esta ação',
  404: 'Recurso não encontrado',
  409: 'Conflito com estado atual do recurso',
  422: 'Dados inválidos',
  429: 'Muitas tentativas. Aguarde e tente novamente',
  500: 'Erro interno no servidor, tente novamente',
  502: 'Serviço indisponível, tente novamente',
  503: 'Serviço indisponível, tente novamente',
}

/**
 * IMPORTANTE: não altera `err.response.data.error.kind` — a vagas-page
 * depende de `kind === 'vaga-com-candidaturas'` para detectar o 409.
 */
export function extractApiErrorMessage(
  err: unknown,
  fallback: string = MENSAGEM_ERRO_GENERICO,
): string {
  if (axios.isAxiosError(err)) {
    const responseData = err.response?.data as { error?: { message?: string } } | undefined
    const message = responseData?.error?.message
    if (typeof message === 'string' && message.trim() !== '') {
      return message
    }

    const status = err.response?.status
    if (status !== undefined && STATUS_FALLBACK_MESSAGES[status]) {
      return STATUS_FALLBACK_MESSAGES[status]
    }
  }

  return fallback
}

export const api: AxiosInstance = axios.create({
  baseURL: env.VITE_API_BASE_URL,
  withCredentials: true,
  timeout: 15_000,
})

export function responseOnFulfilled<T>(res: T): T {
  return res
}

export function responseOnRejected(err: AxiosError): Promise<never> {
  if (err.response?.status === 401 && typeof window !== 'undefined') {
    const next = encodeURIComponent(window.location.pathname + window.location.search)
    if (!window.location.pathname.startsWith('/sign-in')) {
      window.location.assign(`/sign-in?next=${next}`)
    }
  }
  return Promise.reject(err)
}

api.interceptors.response.use(responseOnFulfilled, responseOnRejected)
